import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AutomotiveAftermarketListFacade } from './automotive-aftermarket-list.facade';
import { loadStoreState, setInitialStoreState } from '../../../../common/utils';
import { CatalogSearchCriteriaFacade, CatalogSearchCriteriaType } from '../../catalog-search-criteria';
import { take } from 'rxjs/operators';
import { CatalogSearchCriteria } from '../../../../common/models';

@Injectable({
  providedIn: 'root',
})
export class AutomotiveAftermarketListGuard {
  constructor(
    private automotiveAftermarketFacade: AutomotiveAftermarketListFacade,
    private catalogSearchCriteriaFacade: CatalogSearchCriteriaFacade,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.automotiveAftermarketFacade);
  }

  canDeactivate(): boolean {
    this.catalogSearchCriteriaFacade
      .getSearchCriteriaByCatalogType(CatalogSearchCriteriaType.AutomotiveAftermarket)
      .pipe(take(1))
      .subscribe((searchCriteria: CatalogSearchCriteria) => {
        this.catalogSearchCriteriaFacade.changeSearchCriteriaByCatalogType(
          {
            ...searchCriteria,
            page: 0,
          },
          CatalogSearchCriteriaType.AutomotiveAftermarket,
        );
      });
    return setInitialStoreState(this.automotiveAftermarketFacade);
  }
}
